export default "__VITE_ASSET__aabaf355__"